import { useEffect, useState } from 'react';
export const useNetworkStatus = ({ onConnectionRestablished, onConnectionLost }) => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    useEffect(() => {
        const handleOnline = () => {
            console.log('🛜 Connection re-established at', new Date().toLocaleString());
            onConnectionRestablished?.();
            setIsOnline(true);
        };
        const handleOffline = () => {
            console.log('🛜 Connection lost at', new Date().toLocaleString());
            onConnectionLost?.();
            setIsOnline(false);
        };
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, [onConnectionRestablished, onConnectionLost]);
    return isOnline;
};
